/**
 * Web Style Import
 *
 */

import './style/dnb-progress-indicator.scss'
